import { render, staticRenderFns } from "./ChatArea.vue?vue&type=template&id=b3e468d2&scoped=true"
import script from "./ChatArea.vue?vue&type=script&lang=js"
export * from "./ChatArea.vue?vue&type=script&lang=js"
import style0 from "./ChatArea.vue?vue&type=style&index=0&id=b3e468d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e468d2",
  null
  
)

export default component.exports